import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fill-height d-flex flex-column" }
const _hoisted_2 = { class: "d-flex justify-end mb-6" }
const _hoisted_3 = {
  class: "fill-height",
  style: {"overflow-y":"auto","position":"relative","min-height":"78px"}
}
const _hoisted_4 = { style: {"position":"absolute","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_LatLonChoiceField = _resolveComponent("LatLonChoiceField")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_tooltip, {
        text: _ctx.t('raster.tooltip.add_coordinate'),
        bottom: "",
        "open-delay": 200
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            variant: "outlined",
            "data-testid": "add-empty-coordinate",
            color: "primary",
            style: {"padding":"0","min-width":"36px"},
            width: "36px",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.timeseriesStore.addEmptyCoords()))
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: "primary" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" mdi-plus ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }, 8, ["text"]),
      _createVNode(_component_v_tooltip, {
        text: _ctx.t('raster.tooltip.reset_coordinates'),
        bottom: "",
        "open-delay": 200,
        style: {"z-index":"999999"}
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            variant: "outlined",
            color: "error",
            style: {"padding":"0","min-width":"36px","margin-left":"12px"},
            width: "36px",
            "data-testid": "control-panel-reset-all-coordinates",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.timeseriesStore.resetCoords()))
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: "error" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" mdi-delete-outline ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.timeseriesStore.coords), ([id, coords]) => {
          return (_openBlock(), _createBlock(_component_LatLonChoiceField, {
            id: id,
            key: id,
            ref_for: true,
            ref: _ctx.setRef(id),
            style: {"width":"100%"},
            coords: coords,
            "input-help-is-active": _ctx.inputHelpIsActive,
            class: _normalizeClass(["coordinate", { highlighted: _ctx.timeseriesStore.highlightedCoordID === id }])
          }, null, 8, ["id", "coords", "input-help-is-active", "class"]))
        }), 128))
      ])
    ]),
    _createVNode(_component_v_checkbox, {
      modelValue: _ctx.inputHelpIsActive,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputHelpIsActive) = $event)),
      label: _ctx.t('raster.input_help_label')
    }, null, 8, ["modelValue", "label"])
  ]))
}